import React from "react";

const TokenTabs = ({ activeTab, onChange, isSolana }) => {
  const tabs = [
    { id: "transactions", label: "Transactions" },
    ...(isSolana
      ? []
      : [
          { id: "holders", label: "Holders" },
          { id: "holder-insights", label: "Holder Insights" },
        ]),
    { id: "snipers", label: "Snipers" },
  ];

  return (
    <div className="flex">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`px-6 py-3 font-mono text-sm font-medium transition-colors ${
            activeTab === tab.id
              ? "text-white border-b-2 border-[#4878ff] bg-[rgba(72,120,255,0.1)]"
              : "text-[rgba(255,255,255,0.5)] hover:text-white hover:bg-[rgba(255,255,255,0.05)]"
          }`}
          onClick={(e) => {
            e.stopPropagation(); // Prevent parent button from toggling
            onChange(tab.id);
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TokenTabs;
